<template>
  <div>
    <div v-if="isReconnect" class="reconnect-feedback"> Reconectando... </div>
    <section>
      <div id="spearhead" :style="spearheadStyle">
        <div v-if="clientInfo.name || clientInfo.phone || queue" class="d-flex">
          <div class="spearhead-element">
            <span><i class="fas fa-user"></i><b>Cliente</b></span>
            <p v-if="clientInfo.name">{{ clientInfo.name }}</p>
            <p v-else>----------</p>
          </div>

          <div v-if="clientInfo.phone && !clientInfo.contactPhone" class="spearhead-element">
            <span><i class="fas fa-phone"></i><b>Telefone</b></span>
            <p>{{ formatPhone(clientInfo.phone) }}</p>
          </div>

          <div class="spearhead-element">
            <span><i class="fas fa-headset"></i><b>Fila de Atendimento</b></span>
            <p v-if="queue">{{ queueAlias }}</p>
            <p v-else>----------</p>
          </div>

          <div v-if="clientInfo.cpf" class="spearhead-element">
            <span><i class="fas fa-key"></i><b>CPF/CNPJ</b></span>
            <p>{{ formatCpfCnpj(clientInfo.cpf) }}</p>
          </div>

          <div v-if="clientInfo.contactPhone" class="spearhead-element">
            <span><i class="fas fa-square-phone"></i><b>Telefone Contato</b></span>
            <p>{{ formatPhone(clientInfo.contactPhone) }}</p>
          </div>

          <div v-if="clientInfo.etapa" class="spearhead-element">
            <span><i class="fas fa-location-dot"></i><b>Etapa</b></span>
            <p>{{ clientInfo.etapa }}</p>
          </div>

          <div v-if="clientInfo.email" class="spearhead-element">
            <span><i class="fas fa-at"></i><b>Email</b></span>
            <p>{{ clientInfo.email }}</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

const RIGHT_PANEL_WIDTH = 280;
const LEFT_SIDEBAR_WIDTH = 90;

export default {
  data() {
    return {
      interval: "",
      time: "",
      timeFormat: "",
      protocol: "",
      clientInfo: {
        name: "",
        phone: "",
        cpf: "",
        etapa: "",
        email: "",
        contactPhone: ""
      },
      queue: "",
      queueList: [],
      entry: "",
      rightPanelOpen: false,
      resizeObserver: null,
    };
  },
  computed: {
    ...mapGetters(["isReconnect", "getSpearheadData", "getStoreQueues"]),
    queueAlias() {
      const queue = this.queue ? this.queue : '---'
      if (this.queueList.length) {
        const find = this.queueList.find(el => el.name === this.queue)
        if (find?.alias) return find.alias;
      }
      return queue
    },
    spearheadStyle() {
      if (this.rightPanelOpen) {
        const offset = RIGHT_PANEL_WIDTH / 2;
        return { transform: `translateX(calc(-50% - ${offset}px))` };
      }
      return { transform: 'translateX(-50%)' };
    }
  },
  methods: {
    async setClientData(client) {
      console.log(client);
      if (client.type === 'phone') {
        this.clientInfo.phone = client.originPhone || client.phone;
        this.clientInfo.contactPhone = client.contactPhone;
        this.clientInfo.email = client.email;
        this.clientInfo.etapa = client.etapa;
        this.queue = client.queue;
        this.entry = client.entry;
        if (client.cpf) this.clientInfo.cpf = client.cpf;

        if (client.clientName) {
          this.clientInfo.name = client.clientName;
        } else {
          // Usa o telefone disponível, priorizando originPhone
          const phoneToSearch = client.originPhone || client.phone;

          if (!phoneToSearch) {
            this.clientInfo.name = 'USUÁRIO NÃO CADASTRADO';
            return;
          }

          this.clientInfo.name = await axios(`/share-client-cnpj?share=${phoneToSearch}`)
            .then(({ data }) => {
              const match = data.find((el) => el.phone?.endsWith(phoneToSearch));

              if (match) {
                return match.name;
              }

              return 'USUÁRIO NÃO CADASTRADO';
            });
        }
      }
    },

    // ─── Máscara de Telefone ───────────────────────────────────────────────
    // Suporta: (xx) xxxx-xxxx | (xx) xxxxx-xxxx | +xx (xx) xxxx-xxxx | +xx (xx) xxxxx-xxxx
    formatPhone(tel) {
      if (!tel) return tel;

      // Remove tudo que não for dígito
      const digits = tel.replace(/\D/g, '');

      // Sem código de país (10 ou 11 dígitos): (xx) xxxx-xxxx ou (xx) xxxxx-xxxx
      if (digits.length === 10) {
        return digits.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3');
      }
      if (digits.length === 11) {
        return digits.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
      }

      // Com código de país Brasil +55 (12 ou 13 dígitos com 55 na frente)
      if (digits.length === 12) {
        // +xx (xx) xxxx-xxxx
        return digits.replace(/^(\d{2})(\d{2})(\d{4})(\d{4})$/, '+$1 ($2) $3-$4');
      }
      if (digits.length === 13) {
        // +xx (xx) xxxxx-xxxx
        return digits.replace(/^(\d{2})(\d{2})(\d{5})(\d{4})$/, '+$1 ($2) $3-$4');
      }

      return '+' + digits;
    },

    formatCpfCnpj(value) {
      if (!value) return value;

      const digits = value.replace(/\D/g, '');

      if (digits.length <= 11) {
        return digits
          .replace(/^(\d{3})(\d)/, '$1.$2')
          .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
          .replace(/\.(\d{3})(\d{1,2})$/, '.$1-$2');
      } else {

        return digits
          .replace(/^(\d{2})(\d)/, '$1.$2')
          .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
          .replace(/\.(\d{3})(\d)/, '.$1/$2')
          .replace(/(\d{4})(\d{1,2})$/, '$1-$2');
      }
    },

    observeLayout() {
      const container = this.$el.closest('.main-content, #app-content, [class*="content"], [class*="main"]');
      if (container && window.ResizeObserver) {
        this.resizeObserver = new ResizeObserver(() => {
          const availableWidth = window.innerWidth - LEFT_SIDEBAR_WIDTH;
          const containerWidth = container.offsetWidth;
          this.rightPanelOpen = (availableWidth - containerWidth) >= (RIGHT_PANEL_WIDTH - 20);
        });
        this.resizeObserver.observe(container);
      }
    },
  },
  watch: {
    getSpearheadData(val) {
      this.setClientData(val);
      localStorage.setItem("clienteAtual", JSON.stringify(val));
      this.hasData = !!Object.keys(val).length;

      if (Object.keys(val).length === 0) {
        this.clientInfo = { name: "", phone: "" };
        this.protocol = "";
        this.queue = "";
        this.entry = "";
      }
    },
    getStoreQueues(val) {
      this.queueList = val;
    }
  },
  mounted() {
    if (!localStorage.getItem("clienteAtual")) {
      this.hasData = false;
    } else {
      const clienteAtual = JSON.parse(localStorage.getItem("clienteAtual"));
      if (Object.keys(clienteAtual).length) {
        this.hasData = true;
        this.setClientData(clienteAtual);
      }
    }
    this.$nextTick(() => {
      this.observeLayout();
    });
  },
  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }
};
</script>

<style scoped>
#spearhead {
  display: flex;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  /* z-index: 1; */
  border-radius: 0px 0px 14px 14px;
  font-size: 11px;
  background-color: white;
  margin: 2px;
  box-shadow: -1px 5px 7px 0px #9f9999;
  transition: transform 0.4s ease;
  height: max-content;
}

.d-flex {
  display: flex;
  align-items: stretch;
}

.spearhead-element {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
  border-right: 1px solid lightgray;
  border-left: 1px solid lightgray;
  padding: 4px 10px;
  min-width: 90px;
  flex: 1 1 auto;
}

/* Título sempre em uma linha */
.spearhead-element span {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  font-size: 11px;
  white-space: nowrap;
  text-align: center;
}

.spearhead-element span b {
  font-size: 11px;
  font-weight: 700;
  margin-left: 3px;
}

.spearhead-element span i {
  font-size: 11px;
}

/* Valor em CAIXA ALTA */
.spearhead-element p {
  margin: 2px 0 0 0;
  padding: 0;
  text-transform: uppercase;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.reconnect-feedback {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: gray;
  color: white;
}

.parte-cima {
  box-shadow: 5px 3px 6px -6px black;
  padding: 1px 5px 2px 20px;
  background-color: #ecf0f1;
  max-height: 10em;
  overflow-x: auto;
}

.row {
  margin-right: 0 !important;
}

::-webkit-scrollbar {
  width: 0.18rem;
}

::-webkit-scrollbar-track {
  background: #f38630;
}

::-webkit-scrollbar-thumb {
  background: #1c869a;
}

.espaco-lado-lado {
  max-width: 270px;
  width: 100%;
  margin: 0.1em 0 0.1em 0;
}

.img {
  height: 1.7em;
}
</style>